import {
	ReactionsContainer,
	PageReactionsContainer,
	PageCommentReactionsContainer,
	InlineCommentReactionsContainer,
	FeedReactionsContainer,
	ObjectCommentFooterReactionsContainer,
} from '../styled.tsx';
import { ReactionLocation } from '../types.ts';

export const getWrappingContainerByLocation = (location: ReactionLocation | undefined) => {
	switch (location) {
		case ReactionLocation.PAGE:
		case ReactionLocation.BLOGPOST:
			return PageReactionsContainer;
		case ReactionLocation.PAGE_COMMENT:
			return PageCommentReactionsContainer;
		case ReactionLocation.INLINE_COMMENT:
		case ReactionLocation.EDITOR_INLINE_COMMENT:
			return InlineCommentReactionsContainer;
		case ReactionLocation.FEED_PAGE:
		case ReactionLocation.FEED_BLOGPOST:
		case ReactionLocation.FEED_COMMENT:
			return FeedReactionsContainer;
		case ReactionLocation.OBJECT_COMMENT_FOOTER_PAGE:
		case ReactionLocation.OBJECT_COMMENT_FOOTER_BLOGPOST:
			return ObjectCommentFooterReactionsContainer;
		default:
			return ReactionsContainer;
	}
};

export const getContentTypeByLocation = (location: ReactionLocation) => {
	switch (location) {
		case ReactionLocation.PAGE:
		case ReactionLocation.FEED_PAGE:
		case ReactionLocation.OBJECT_COMMENT_FOOTER_PAGE:
			return 'page';
		case ReactionLocation.BLOGPOST:
		case ReactionLocation.FEED_BLOGPOST:
		case ReactionLocation.OBJECT_COMMENT_FOOTER_BLOGPOST:
			return 'blogpost';
		case ReactionLocation.PAGE_COMMENT:
		case ReactionLocation.INLINE_COMMENT:
		case ReactionLocation.EDITOR_INLINE_COMMENT:
		case ReactionLocation.FEED_COMMENT:
			return 'comment';
	}
};

export const getBooleanLocationTypes = (location: ReactionLocation) => {
	let isPage = false;
	let isComment = false;
	let isFeed = false;

	switch (location) {
		case ReactionLocation.PAGE:
		case ReactionLocation.BLOGPOST:
		case ReactionLocation.OBJECT_COMMENT_FOOTER_PAGE:
		case ReactionLocation.OBJECT_COMMENT_FOOTER_BLOGPOST:
			isPage = true;
			break;
		case ReactionLocation.FEED_PAGE:
		case ReactionLocation.FEED_BLOGPOST:
			isFeed = true;
			break;
		case ReactionLocation.PAGE_COMMENT:
		case ReactionLocation.INLINE_COMMENT:
		case ReactionLocation.EDITOR_INLINE_COMMENT:
			isComment = true;
			break;
		// Feed comment is a special case that looks and queries like feed, but is technically a comment
		case ReactionLocation.FEED_COMMENT:
			isComment = true;
			isFeed = true;
			break;
	}

	return { isPage, isComment, isFeed };
};
